import styled from 'styled-components';

const TertiaryButton = styled.button`
  background: none;
  border: 1px solid ${Styles.color.grey.four};
  border-radius: ${Styles.borderRadius};
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9375rem;
  padding: 0.6rem 1rem;
  width: 100%;

  &:active {
    background: ${Styles.color.grey.four};
    border-color: ${Styles.color.grey.four};
    transform: scale(0.95);
    transition: transform 200ms ease-out;
  }
  &:hover {
    border-color: ${Styles.color.grey.three};
  }
`;

export default TertiaryButton;
